export default "__VITE_ASSET__DydpS4Dx__"